import mdsRequire from 'dojo/require';
/// <reference path="FilterPanelTypes.ts" />
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FilterPanelOption.html?raw';
import on from 'dojo/on';

import Multiselect from '../Multiselect/Multiselect';

import SearchSelect from '../SearchSelect/SearchSelect';

// interfaces für die Daten:
import "../../UI/FilterPanel/FilterPanelTypes";
import FilterPanelSection from './FilterPanelSection';
import DateTimeInput from '../DateTimeInput/DateTimeInput';
import Edit from '../Edit/Edit';
import ColorPicker from '../ColorPicker/ColorPicker';
import HintBox from '../HintBox/HintBox';

import { FilterPanelTypes, FilterPanelFormat, FilterOptionTypes } from "../../../moreCore/UI/FilterPanel/FilterPanelTypes";
import { AccessibilityLabelsHelper, TranslationHelpers } from "../../../more/Helpers";
import PlaintextEditContainer from '../Edit/PlaintextEditContainer/PlaintextEditContainer';
import { SelectEntityDialog } from "../../_loadingHelpers/SelectEntityDialog";





class FilterPanelOption extends compose(_WidgetBaseSP) {

    templateString: any = template;

    private date_Selectbutton: HTMLElement;
    private date_Container: HTMLElement;
    private date_Label: HTMLElement;
    private date_selectedIcon: HTMLElement;
    private date_Input: HTMLInputElement;

    private text_Selectbutton: HTMLElement;
    private text_Container: HTMLElement;
    private text_Label: HTMLElement;
    private text_selectedIcon: HTMLElement;
    private text_Input: HTMLInputElement;

    private select_Selectbutton: HTMLElement;
    private select_Container: HTMLElement;
    private select_InputContainer: HTMLElement;
    private select_Label: HTMLElement;
    private select_selectedIcon: HTMLElement;
    //select_Input: HTMLInputElement;
    private select_Widget: MdsLax<InstanceType<typeof SearchSelect>>;

    private toggleButton_Label: HTMLElement;
    private toggleButton_Button: HTMLElement;
    private toggleButton_Icon: HTMLElement;
    private toggleButton_Container: HTMLElement;

    private infoText_Heading: HTMLElement;
    private infoText_Content: HTMLElement;
    private infoText_Container: HTMLElement;

    private multiSelect_Selectbutton: HTMLElement;
    private multiSelect_Container: HTMLElement;
    private multiSelect_Label: HTMLElement;
    private multiSelect_selectedIcon: HTMLElement;
    private multiSelect_InputContainer: HTMLDivElement;
    private multiSelect_Widget: MdsLax<InstanceType<typeof Multiselect>>;

    private multiline_Selectbutton: HTMLElement;
    private multiline_Container: HTMLElement;
    private multiline_Label: HTMLElement;
    private multiline_selectedIcon: HTMLElement;
    private multiline_InputContainer: HTMLDivElement;
    private multiline_Widget: MdsLax<InstanceType<typeof Edit>>;

    private htmledit_Selectbutton: HTMLElement;
    private htmledit_Container: HTMLElement;
    private htmledit_Label: HTMLElement;
    private htmledit_selectedIcon: HTMLElement;
    private htmledit_InputContainer: HTMLDivElement;
    private htmledit_Widget: MdsLax<InstanceType<typeof PlaintextEditContainer>>;

    private hintbox_Selectbutton: HTMLElement;
    private hintbox_Container: HTMLElement;
    private hintbox_Label: HTMLElement;
    private hintbox_selectedIcon: HTMLElement;
    private hintbox_InputContainer: HTMLDivElement;
    private hintbox_Widget: any;

    private dateTime_Selectbutton: HTMLElement;
    private dateTime_Container: HTMLElement;
    private dateTime_Label: HTMLElement;
    private dateTime_selectedIcon: HTMLElement;
    private dateTime_InputContainer: HTMLDivElement;
    private dateTime_Widget: MdsLax<InstanceType<typeof DateTimeInput>>;

    private color_Selectbutton: HTMLElement;
    private color_Container: HTMLElement;
    private color_Label: HTMLElement;
    private color_selectedIcon: HTMLElement;
    private color_InputContainer: HTMLDivElement;
    private color_Widget: MdsLax<InstanceType<typeof ColorPicker>>;

    private _targetInput: HTMLInputElement;
    private _targetLabel: HTMLElement;
    private _targetIcon: HTMLElement;
    private _targetContainer: HTMLElement;
    private _targetSelect: HTMLElement;

    private txtParameterInfo: HTMLElement;

    warningNode: HTMLElement;


    private type: FilterOptionTypes = FilterOptionTypes.toggleButton; // combobox, selectentity... ?
    private label: string;// = "?";

    // Attribut oder sonstiger eindeutiger Bezeichner für die API zum Auslesen
    mandatory: boolean = false;
    valid: boolean = true;
    readonly: boolean = false;
    hidden: boolean = false;
    selected: boolean = false;
    emptyIfDeselected: boolean = false;
    section: MdsLax<InstanceType<typeof FilterPanelSection>> = null;

    alternativeMandatoryMode: boolean = false;

    private data: FilterPanelTypes.OptionConfig = null;

    private oldValue: any;

    private _setHiddenAttr(value: boolean) {

        this.hidden = value === true;

        if (this.hidden != true) {
            this.UiModder.domClass.add(this.domNode, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.domNode, "w3-hide");
        }
    }

    getData(): FilterPanelTypes.OptionConfig {
        return this.data;
    }

    getValueLabel(): string {
        let selectedValue = this.getValue();
        if (!selectedValue) return "";
        for (let value of this.getData()?.valueList) {
            if (value.value === selectedValue) {
                return value.label;
            }
        }
        return "";
    } 

    updateData(newData?: Partial<FilterPanelTypes.OptionConfig>) {
        if (!newData) return;

        for (let property in newData) {

            // einfache Properties direkt übertragen
            switch (property) {
                case "label":
                case "infoText":
                case "isMandatory":
                case "minLength":
                case "maxLength":
                case "minValue":
                case "selected":
                case "maxValue":
                    (this.data as any)[property] = newData[property];
                    break;
            }
        }

        
        if (this.type == FilterOptionTypes.combobox || this.type == FilterOptionTypes.multiselect) {
            // neue Werteliste?
            if (newData.valueList) {
                this.data.valueList = lang.clone(newData.valueList);
            }

            if (typeof (newData.value) == "undefined") {
                // abgleichen ob bereits selektierte Werte überhaupt noch verfügbar sind, ggf. abwählen

                let selectableValues = this.data.valueList.map(entry => entry.value);
                let currentValue = this.data.value;
                if (currentValue) {
                    if (this.type == FilterOptionTypes.combobox) {
                        let strValue = currentValue as string;
                        if (selectableValues.indexOf(strValue) == -1) {
                            currentValue = null;
                        }
                    } else if (this.type == FilterOptionTypes.multiselect) {
                        let currentValues = currentValue as string[];
                        let validValues = [];
                        for (let value of currentValues) {
                            if (selectableValues.indexOf(value) != -1) {
                                validValues.push(value);
                                let valueEntry = this.data.valueList.filter(entry => entry.value == value)[0];
                                if (valueEntry) valueEntry.selected = true;
                            }
                        }

                        currentValue = validValues;
                    }

                    // deselektieren, falls nichts mehr gewählt ist und kein Pflichtfeld:
                    this.data.value = currentValue;
                    if (!this.data.value && !this.data.isMandatory) this.data.selected = false;
                }
            }
        }

        if (typeof (newData.value) != "undefined") {
            if (newData.value != null) {
                this.data.value = lang.clone(newData.value);
            } else {
                this.data.value = null;
            }
        }

        this.setData(this.data);

    }
    setData(data?: FilterPanelTypes.OptionConfig) {
        //console.trace("filteroption set data", data, this.data);


        if (!data) data = this.data;
        else {
            this.data = lang.clone(data);
        }

        data = this.data;
        //this._setTypeAttr(data.type as any);

        if (!data) {
            console.warn(this.id + ": no config data", this);
            return;
        }

        this.mandatory = data.isMandatory;

        // TYP SETZEN
        {
            let bValidType = false;

            //console.debug("_setTypeAttr", value, this.data);

            // alles ausblenden:
            this.hideNode(this.select_Container);
            this.hideNode(this.infoText_Container);
            this.hideNode(this.toggleButton_Container);
            this.hideNode(this.date_Container);
            this.hideNode(this.dateTime_Container);
            this.hideNode(this.text_Container);
            this.hideNode(this.multiSelect_Container);
            this.hideNode(this.multiline_Container);


            //this.UiModder.domClass.remove(this.domNode, [FilterOptionTypes.combobox,
            //FilterOptionTypes.date,
            //FilterOptionTypes.float,
            //FilterOptionTypes.infotext,
            //FilterOptionTypes.multiselect,
            //FilterOptionTypes.number,
            //FilterOptionTypes.text,
            //    FilterOptionTypes.toggleButton]);

            let type = data.type;

            this.UiModder.domAttr.set(this.domNode, "data-option-type", type);

            // einblenden was jetzt gewählt ist:
            if (type == FilterOptionTypes.infotext) {
                this.type = type;

                this._targetInput = null; // bei Infotext sowieso nicht
                this._targetContainer = this.infoText_Container;
                this._targetIcon = null;
                this._targetLabel = this.infoText_Heading;
                this._targetSelect = null;

                let value = data.value as string;
                if (TranslationHelpers.canTranslate(value)) value = TranslationHelpers.translate(value);

                this.setValue(value);


                bValidType = true;
                this.infoText_Content.setAttribute("data-cy", data.name + ":filter_infotext");
                this.infoText_Content.setAttribute("data-e2e-role", type);
            } else if (type == FilterOptionTypes.toggleButton) {
                this.type = type;

                this.data.value = this.data.selected;

                this._targetInput = null; // gibts beim Toggle nicht, weil das ja selber nur on/off kann
                this._targetContainer = this.toggleButton_Container;
                this._targetIcon = this.toggleButton_Icon;
                this._targetLabel = this.toggleButton_Label;
                this._targetSelect = this.toggleButton_Button;


                bValidType = true;
                
                this.toggleButton_Button.setAttribute("data-cy", data.name + ":filter_SelectButton");
                this.toggleButton_Button.setAttribute("data-e2e-role", "button");
            } else if (type == FilterOptionTypes.text || type == FilterOptionTypes.number || type == FilterOptionTypes.float) {
                this.type = type;

                this._targetInput = this.text_Input;
                this._targetContainer = this.text_Container;
                this._targetIcon = this.text_selectedIcon;
                this._targetLabel = this.text_Label;
                this._targetSelect = this.text_Selectbutton;

                if (type == FilterOptionTypes.float || type == FilterOptionTypes.number) {
                    this.type = type;

                    this._targetInput.type = "number";

                    if (typeof (this.data.minValue) != "undefined" && this.data.minValue != null) {
                        this._targetInput.min = this.data.minValue.toString();
                    }
                    if (typeof (this.data.maxValue) != "undefined" && this.data.maxValue != null) {
                        this._targetInput.max = this.data.maxValue.toString();
                    }

                    if (type == FilterOptionTypes.float) {
                        this._targetInput.step = "0.01";
                    }
                } else {
                    if (typeof (this.data.maxLength) != "undefined" && this.data.maxLength != null) {
                        this._targetInput.maxLength = this.data.maxLength;
                    }
                    if (typeof (this.data.minLength) != "undefined" && this.data.minLength != null) {
                        this._targetInput.minLength = this.data.minLength;
                    }
                }

                bValidType = true;
                this.text_Input.setAttribute("data-cy", data.name + ":filter_text");
                this.text_Input.setAttribute("data-e2e-role", type);
                this.text_Selectbutton.setAttribute("data-cy", data.name + ":filter_SelectButton");
                this.text_Selectbutton.setAttribute("data-e2e-role", "button");
            } else if (type == FilterOptionTypes.date) {
                this.type = type;

                this._targetInput = this.date_Input;
                this._targetContainer = this.date_Container;
                this._targetIcon = this.date_selectedIcon;
                this._targetLabel = this.date_Label;
                this._targetSelect = this.date_Selectbutton;

                bValidType = true;
                this.date_Selectbutton.setAttribute("data-cy", data.name + ":filter_SelectButton");
                this.date_Selectbutton.setAttribute("data-e2e-role", "button");
                this.date_Input.setAttribute("data-cy", data.name + ":filter_date");
                this.date_Input.setAttribute("data-e2e-role", type);
            } else if (type == FilterOptionTypes.combobox) {
                this.type = type;

                let searchSelect = new SearchSelect();
                searchSelect.setCyName((this.section?.title ? this.section.title + ":" : "") + data.name);
                this.UiModder.domConstruct.empty(this.select_InputContainer);
                this.UiModder.domConstruct.place(searchSelect.domNode, this.select_InputContainer);
                this.select_Widget = searchSelect;
                on(searchSelect, "change", lang.hitch(this, this._onChange_SelectInput));

                //this._targetInput = this.select_Input;
                this._targetContainer = this.select_Container;
                this._targetIcon = this.select_selectedIcon;
                this._targetLabel = this.select_Label;
                this._targetSelect = this.select_Selectbutton;

                if (typeof (this.data.valueList) != "undefined") {

                    let values: Array<string> = [];
                    let labels: Array<string> = [];
                    let colors: Array<Partial<more.EntityAPIColor>> = [];
                    let preselected: string = this.data.value as string;
                    let selectable: Array<boolean> = [];

                    for (let i = 0; i < this.data.valueList.length; i++) {
                        let selectValueData = this.data.valueList[i];

                        values.push(selectValueData.value);
                        labels.push(selectValueData.label);
                        selectable.push(selectValueData.disabled != true);

                        if (selectValueData.colorBG && selectValueData.colorTXT) colors.push({
                            BackColor: {
                                Hex: selectValueData.colorBG
                            },
                            TextColor: {
                                Hex: selectValueData.colorTXT
                            }
                        } as Partial<more.EntityAPIColor>)
                    }

                    if (colors.length && colors.length == values.length) {
                        searchSelect.setOptionsWithColor(values, labels, colors, data.value as string, selectable);
                    } else {
                        searchSelect.setOptions(values, labels, data.value as string, selectable);
                    }

                }

                bValidType = true;
                this.select_Selectbutton.setAttribute("data-cy", data.name + ":filter_SelectButton");
                this.select_Selectbutton.setAttribute("data-e2e-role", "button");
                this.select_InputContainer.setAttribute("data-cy", data.name + ":filter_combobox");
                this.select_InputContainer.setAttribute("data-e2e-role", type);

            } else if (type == FilterOptionTypes.multiselect) {
                this.type = type;

                let mSelect: MdsLax<InstanceType<typeof Multiselect>> = new Multiselect();
                mSelect.setCyName((this.section?.title ? this.section.title + ":" : "") + data.name);
             
                
                this.multiSelect_Widget = mSelect;
                on(mSelect, "change", lang.hitch(this, this._onChange_MultiSelectInput, mSelect));
                this.UiModder.domConstruct.empty(this.multiSelect_InputContainer);
                this.UiModder.domConstruct.place(mSelect.domNode, this.multiSelect_InputContainer);

                this._targetContainer = this.multiSelect_Container;
                this._targetIcon = this.multiSelect_selectedIcon;
                this._targetLabel = this.multiSelect_Label
                this._targetSelect = this.multiSelect_Selectbutton;
                //this._targetInput = mSelect;

                if (typeof (this.data.valueList) != "undefined") {
                    let values: Array<string> = [];
                    let labels: Array<string> = [];
                    let preselected: Array<boolean> = [];
                    let selectable: Array<boolean> = [];
                    let colors: Array<Partial<more.EntityAPIColor>> = [];

                    for (let i = 0; i < this.data.valueList.length; i++) {
                        let selectValueData = this.data.valueList[i];

                        values.push(selectValueData.value);
                        labels.push(selectValueData.label);
                        preselected.push(selectValueData.selected);
                        selectable.push(selectValueData.disabled != true);

                        if (selectValueData.colorBG && selectValueData.colorTXT) colors.push({
                            BackColor: {
                                Hex: selectValueData.colorBG
                            },
                            TextColor: {
                                Hex: selectValueData.colorTXT
                            }
                        } as Partial<more.EntityAPIColor>)

                    }

                    if (colors.length && colors.length == values.length) {
                        mSelect.setOptionsWithColor(values, labels, colors, preselected, selectable, null, true);
                    } else {
                        mSelect.setOptions(values, labels, preselected, selectable, null, true);
                    }

                    this.data.value = mSelect.getValue();
                }

                if (typeof (this.data.maxLength) != "undefined") {
                    if (this.data.maxLength < 1) {
                        this.data.maxLength = undefined;
                    }
                }

                bValidType = true;
                this.multiSelect_Selectbutton.setAttribute("data-cy", data.name + ":filter_SelectButton");
                this.multiSelect_Selectbutton.setAttribute("data-e2e-role", "button");
                this.multiSelect_InputContainer.setAttribute("data-cy", data.name + ":filter_Multiselect");
                this.multiSelect_InputContainer.setAttribute("data-e2e-role", type);


            } else if (type == FilterOptionTypes.dualcolor || type == FilterOptionTypes.simplecolor) {
                this.type = type;


                let colorpicker: MdsLax<InstanceType<typeof ColorPicker>> = new ColorPicker();
                this.color_Widget = colorpicker;


                if (this.type == FilterOptionTypes.dualcolor) {
                    colorpicker.setUseTextColor(true);
                } else {
                    colorpicker.setUseTextColor(false);
                }

                colorpicker.setUsePreview(false);

                // wenn es schon eine value gibt, dann müssen wir sie jetzt schon einmal setzen und auslesen, sonst gibts dann blöde
                // change-Effekte wenn sich das Format beim ersten Initialisieren ändert.
                if (this.data?.value) {
                    //debugger;
                    colorpicker.setValue(this.data.value as any);
                    this.data.value = colorpicker.getDualColor(false, true) as any;
                }

                on(colorpicker, "change", lang.hitch(this, this._onChange_ColorPickerInput, colorpicker));
                this.UiModder.domConstruct.empty(this.color_InputContainer);
                this.UiModder.domConstruct.place(colorpicker.domNode, this.color_InputContainer);

                this._targetContainer = this.color_Container;
                this._targetIcon = this.color_selectedIcon;
                this._targetLabel = this.color_Label;
                this._targetSelect = this.color_Selectbutton;


                bValidType = true;
            } else if (type == FilterOptionTypes.datetime) {
                this.type = type;


                let input: MdsLax<InstanceType<typeof DateTimeInput>> = new DateTimeInput();
                this.dateTime_Widget = input;
                on(input, "change", lang.hitch(this, this._onChange_DateTimeInput));
                this.UiModder.domConstruct.empty(this.dateTime_InputContainer);
                this.UiModder.domConstruct.place(input.domNode, this.dateTime_InputContainer);

                this._targetContainer = this.dateTime_Container;
                this._targetIcon = this.dateTime_selectedIcon;
                this._targetLabel = this.dateTime_Label
                this._targetSelect = this.dateTime_Selectbutton;
                //this._targetInput = mSelect;

                bValidType = true;
                this.dateTime_Selectbutton.setAttribute("data-cy", data.name + ":filter_SelectButton");
                this.dateTime_Selectbutton.setAttribute("data-e2e-role", "button");
                this.dateTime_InputContainer.setAttribute("data-cy", data.name + ":filter_datetime");
                this.dateTime_InputContainer.setAttribute("data-e2e-role", type);

            } else if (type == FilterOptionTypes.multilinetext) {
                this.type = type;


                let input: MdsLax<InstanceType<typeof Edit>> = new Edit();
                this.multiline_Widget = input;

                input.setIsResizeable("vertical");
                input.setIsMultiline(true);
                input.setRows(3);

                on(input, "change", lang.hitch(this, this._onChange_MultilineInput));
                this.UiModder.domConstruct.empty(this.multiline_InputContainer);
                this.UiModder.domConstruct.place(input.domNode, this.multiline_InputContainer);

                this._targetContainer = this.multiline_Container;
                this._targetIcon = this.multiline_selectedIcon;
                this._targetLabel = this.multiline_Label
                this._targetSelect = this.multiline_Selectbutton;
                //this._targetInput = mSelect;



                if (typeof (this.data.maxLength) != "undefined") {
                    if (this.data.maxLength < 1) {
                        this.data.maxLength = undefined;
                    }
                }

                if (this.data.maxLength) input.setMaxLength(this.data.maxLength);



                bValidType = true;
                this.multiline_Selectbutton.setAttribute("data-cy", data.name + ":filter_SelectButton");
                this.multiline_Selectbutton.setAttribute("data-e2e-role", "button");
                this.multiline_InputContainer.setAttribute("data-cy", data.name + ":filter_multiline");
                this.multiline_InputContainer.setAttribute("data-e2e-role", type);

            } else if (type == FilterOptionTypes.htmledit) {
                this.type = type;

                let input: MdsLax<InstanceType<typeof PlaintextEditContainer>> = new PlaintextEditContainer();
                this.htmledit_Widget = input;


                on(input, "change", lang.hitch(this, this._onChange_HtmlEditInput));
                this.UiModder.domConstruct.empty(this.htmledit_InputContainer);
                this.UiModder.domConstruct.place(input.domNode, this.htmledit_Container);

                input.deactivatePlaintextEditor(true);

                this._targetContainer = this.htmledit_Container;
                this._targetIcon = this.htmledit_selectedIcon;
                this._targetLabel = this.htmledit_Label;
                this._targetSelect = this.htmledit_Selectbutton;

                bValidType = true;
                this.htmledit_Selectbutton.setAttribute("data-cy", data.name + ":filter_SelectButton");
                this.htmledit_Selectbutton.setAttribute("data-e2e-role", "button");
                this.htmledit_InputContainer.setAttribute("data-cy", data.name + ":filter_htmlEdit");
                this.htmledit_InputContainer.setAttribute("data-e2e-role", type);

            } else if (type == FilterOptionTypes.hintbox) {
                this.type = type;

                //Lazy loading to circumvent cyclic dependency
                let HintBox = mdsRequire("../HintBox/HintBox");
                let input: MdsLax<InstanceType<typeof HintBox>> = new HintBox();
                //let input: any = null;
                this.hintbox_Widget = input;



                if (this.data["minLength"]) {
                    this.hintbox_Widget.minLetterCount = this.data["minLength"];
                }
                if (this.data["labelAttribute"]) {
                    input.setLabelAttribute(this.data["labelAttribute"]);
                } else {
                    input.setLabelAttribute("$Displayname");
                }
                if (this.data["valueAttribute"]) {
                    input._setValueAttributeAttr(this.data["valueAttribute"]);
                } else {
                    input._setValueAttributeAttr("ID");
                }
                if (this.data["searchCallfunction"]) {
                    input.setCallfunction(this.data["searchCallfunction"]);
                } else {
                    console.error("No search callfunction provided for hintbox!");
                    return;
                }
                if (this.data["configCallfunction"]) {
                    let mode = this.data["mode"];
                    let configCallfunction = this.data["configCallfunction"];
                    this.hintbox_Widget.addInlineButton(lang.hitch(this, this._onClickSEDButton, mode, configCallfunction));
                } else {
                    this.hintbox_Widget.enableSelectEntityDialog();
                }

                on(input, "change", lang.hitch(this, this._onChange_HintboxInput));
                this.UiModder.domConstruct.empty(this.hintbox_InputContainer);
                this.UiModder.domConstruct.place(input.domNode, this.hintbox_InputContainer);

                this._targetContainer = this.hintbox_Container;
                this._targetIcon = this.hintbox_selectedIcon;
                this._targetLabel = this.hintbox_Label;
                this._targetSelect = this.hintbox_Selectbutton;

                bValidType = true;
                this.hintbox_Selectbutton.setAttribute("data-cy", data.name + ":filter_SelectButton");
                this.hintbox_Selectbutton.setAttribute("data-e2e-role", "button");
                this.hintbox_InputContainer.setAttribute("data-cy", data.name + ":filter_hintbox");
                this.hintbox_InputContainer.setAttribute("data-e2e-role", type);

            }

            if (bValidType === true) {
                this.hideNode(this._targetContainer, false);
            } else {
                return;
            }
        }


        // MANDATORY
        {
            let alternativeMandatoryMode = this.alternativeMandatoryMode;

            if (typeof (alternativeMandatoryMode) == "boolean") {
                /* Die Filteroption wird ihr Select immer ausblenden und ist immer selektiert.
                 * Dadurch können leere Werte abgeschickt werden.
                 * Falls die Option Pflicht ist, muss sie weiterhin ausgefüllt werden.
               */
                this.alternativeMandatoryMode = alternativeMandatoryMode !== false;
            }

            if (this.type == FilterOptionTypes.infotext) return;

            this._handleMandatoryStyle();

            let previouslyValid = this.valid;

            this.validateValue();

            if (this.valid != previouslyValid) {
                this.emit("valueChanged");
            }
        }

        this._setNameAttr(data.name);
        this._setLabelAttr(data.label);
        this.setInfoText(data.infoText);

        this.emptyIfDeselected = data.emptyValueIfDeselected === true;

        this.setValue(data.value);




        this._setSelectedAttr(data.selected === true);
    }

    private _onClickSEDButton(mode: string, configCallfunction: string, evt: MouseEvent) {
        this.RequestManager.callfunction(configCallfunction, { mode: mode }, lang.hitch(this, this._onLoadSEDConfigResponse, mode), lang.hitch(this, this._onLoadSEDConfigError));
    }

    private _onLoadSEDConfigResponse(mode: string, response) {
        //Lazy loading to circumvent cyclic dependency
        let SelectEntityDialogClass: any = mdsRequire("moreCore/UI/SelectEntityDialog/SelectEntityDialog");
        let sed: MdsLax<InstanceType<typeof SelectEntityDialog<any>>> = (new SelectEntityDialogClass()) as MdsLax<InstanceType<typeof SelectEntityDialog<any>>>;
        sed.setConfiguration(response, lang.hitch(this, this._onSEDCallback, mode));
        sed.show();
    }

    private _onLoadSEDConfigError(error) {
        console.error(error);
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<any>) {
        if (items && items.length > 0) {
            let entity = items[0].entry.data;
            if (this.hintbox_Widget) this.hintbox_Widget.setValue(entity);
        }
    }

    private _handleMandatoryStyle() {
        let selectButtonHidden = this.mandatory === true || this.alternativeMandatoryMode == true;
        if (selectButtonHidden) {
            if (this.type == FilterOptionTypes.toggleButton) {
                selectButtonHidden = false;
            } else {
                this._setSelectedAttr(true);
            }

        }

        this.UiModder.domClass.toggle(this.domNode, "mandatory", selectButtonHidden);

        if (this._targetSelect) {
            if (selectButtonHidden) {
                if (this.type == FilterOptionTypes.toggleButton) {
                    //this.UiModder.domClass.add(this.toggleButton_Button, "w3-disabled");
                    //this.UiModder.domClass.remove(this.toggleButton_Button, "hoverDark");
                    // obsolet
                } else {
                    //this.hideNode(this._targetSelect);
                    this.UiModder.domClass.toggle(this._targetSelect, "hoverAuto", false);
                }

            } else {
                if (this.type == FilterOptionTypes.toggleButton) {
                    //    this.UiModder.domClass.remove(this.toggleButton_Button, "w3-disabled");
                    //    this.UiModder.domClass.add(this.toggleButton_Button, "hoverDark");
                } else {
                    //this.hideNode(this._targetSelect, false);
                    this.UiModder.domClass.toggle(this._targetSelect, "hoverAuto", true);
                }
            }
        } else {
            
        }
    }

    private _setNameAttr(value: string): void{
        this.data.name = value;
    }

    private _setLabelAttr(value: string): void {
        if (TranslationHelpers.canTranslate(value)) value = TranslationHelpers.translate(value);

        this.label = value;
        //console.debug("_setLabelAttr", value, this.type, this._targetLabel);

        // alle Labels setzen
        this.UiModder.domAttr.set(this._targetLabel, "innerHTML", this.label);
        if (!value && this.type === FilterOptionTypes.htmledit) this.hideNode(this._targetLabel, true);
        if (value && this.type === FilterOptionTypes.htmledit) this.hideNode(this._targetLabel, true);
        //domAttr.set(this.date_Label, "for", domAttr.get(this.date_Input, "id"));
    }

    setInfoText(text: string) {
        if (TranslationHelpers.canTranslate(text)) text = TranslationHelpers.translate(text);

        this.UiModder.domAttr.set(this.txtParameterInfo, "innerHTML", text);
        this.hideNode(this.txtParameterInfo.parentElement, !text);
    }

    setReadonly(bReadonly: boolean) {
        this._setReadonlyAttr(bReadonly !== false);
    }
    private _setReadonlyAttr(value: boolean): void {

        this.readonly = value === true;

        this.disableNode(this.domNode, this.readonly);
    }

    private _setSelectedAttr(value: boolean): void {

        //console.debug("_setSelectedAttr", value, this.data, "Mandatory?", this.mandatory);


        if (this.type == FilterOptionTypes.infotext) return;

        if (this.mandatory == true) {
            value = true;
        }

        this.data.selected = value === true;
        this.selected = this.data.selected;

        this.UiModder.domClass.toggle(this.domNode, "deselected", !this.data.selected);
        this.UiModder.domClass.toggle(this.domNode, "selected", this.data.selected);
        this.UiModder.domClass.toggle(this._targetIcon, "fas fa-check-circle", this.data.selected);
        this.UiModder.domClass.toggle(this._targetIcon, "far fa-circle", !this.data.selected);


        //this.emit("valueChanged", this);
        //this.emit("change", this);
    }

    getType(): FilterOptionTypes {
        return this.type;
    }

    getInput(): HTMLElement {
        switch (this.type) {
            case FilterOptionTypes.combobox:
                return this.select_Widget["input"];
                break;
            case FilterOptionTypes.multiselect:
                return this.multiSelect_Widget["input"];
                break;
        }
        return this._targetInput;
    }

    focusInput() {
        let node = null;
        try {
            switch (this.type) {
                case FilterOptionTypes.combobox:
                case FilterOptionTypes.multiselect:
                    node = this._targetInput["input"];
                    break;

                default:
                    if (this._targetInput["inputNode"]) node = this._targetInput["inputNode"];
                    else if (this._targetInput["input"]) node = this._targetInput["input"];
                    else node = this._targetInput;
                    break;
            }

            if (node && node.focus) node.focus();
        } catch (ex) {

        }
    }

    setValue(value: string | number | boolean | Array<string>, suppressAutoSelect?: boolean): void {
        this._setValueAttr(value, false, suppressAutoSelect);
    }

    getValue(emptyIfDeselected: boolean = true): string | boolean | number | Array<string> {

        if (!this.data.selected) return null;

        if (this.type === FilterOptionTypes.htmledit) return btoa(this.data.value as string);

        return this.data.value;
    }

    private _setValueAttr(value: string | number | boolean | Array<string>, bSkipInputChange?: boolean, suppressAutoSelect?: boolean): void {

        //console.debug("_setValueAttr", value);

        this.data.value = value;


        if (this.type == FilterOptionTypes.infotext) {
            this.hideNode(this.infoText_Content, !value);
            this.UiModder.domAttr.set(this.infoText_Content, "innerHTML", value);

        }

        else if (bSkipInputChange !== true) {
            if (this.type == FilterOptionTypes.toggleButton) {
                if (value == "true" || value === true) {
                    this._setSelectedAttr(true);
                } else {
                    this._setSelectedAttr(false);
                }
            } else if (this.type == FilterOptionTypes.multiselect) {
                if (value) {
                    this.multiSelect_Widget._setValueAttr(value); // der setter frisst fast alles, sogar true wenn einfach alles selektiert werden soll
                }
            } else if (this.type == FilterOptionTypes.multilinetext) {
                if (value) {
                    this.multiline_Widget._setValueAttr(value);
                }
            } else if (this.type == FilterOptionTypes.htmledit) {
                if (value) {
                    this.htmledit_Widget.setValue(value as any, true);
                }
            } else if (this.type == FilterOptionTypes.hintbox) {
                if (value) {
                    this.hintbox_Widget.setValue(value as any);
                }
            } else if (this.type == FilterOptionTypes.datetime) {
                if (value) {
                    this.dateTime_Widget._setValueAttr(value);
                }
            } else if (this.type == FilterOptionTypes.combobox) {
                if (value) {
                    this.select_Widget.setValue(value, true); // der setter frisst fast alles, sogar true wenn einfach alles selektiert werden soll
                }
            } else if (this.type == FilterOptionTypes.float) {
                if (value === "" || value == null || typeof (value) == "undefined") {
                    this._targetInput.value = null;
                }
                else if (typeof (value) == "string") {
                    let numberValue: number = parseFloat(value);
                    this.data.value = numberValue;
                    this._targetInput.value = value;
                }
                else if (typeof (value) == "number") {
                    this._targetInput.value = value.toString();
                }
            } else if (this.type == FilterOptionTypes.dualcolor || this.type == FilterOptionTypes.simplecolor) {
                this.color_Widget.setValue(value as any);
            }
            else {
                //debugger;
                this._targetInput.value = <string>value;
            }
        }
        //} else if (this.type == FilterOptionTypes.date) {
        //    this.date_Input.value = <string>value;
        //}
        //else if (this.type == FilterOptionTypes.text) {
        //    this.text_Input.value = <string>value;
        //}

        if (value != this.oldValue) {
            this.validateValue();
            this.emit("valueChanged");
            this.emit("change", this);
        }
        this.oldValue = value;
    }

    private setMandatoryxxx(value: boolean, alternativeMandatoryMode?: boolean): void {

    }

    /**
    * Die Filteroption wird ihr Select immer ausblenden und ist immer selektiert.
    * Dadurch können leere Werte abgeschickt werden.
    * Falls die Option Pflicht ist, muss sie weiterhin ausgefüllt werden.
    * @param bAlternateMode
    */
    setAlternativeMandatoryBehaviour(bAlternateMode: boolean) {
        this.alternativeMandatoryMode = bAlternateMode !== false;

        this._handleMandatoryStyle();
        this.validateValue();
    }

    toggleSelected(bOverride?: boolean): void {
        if (this.readonly === true) {
            return;
        }

        if (this.type == FilterOptionTypes.infotext) return;

        if (this.selected != true || bOverride === true) {
            this._setSelectedAttr(true);
        } else if (this.selected == true || bOverride === false) {
            this._setSelectedAttr(false);
        }

        // wenn die Option "ausleeren wenn abgewählt" aktiv ist, dann Wert auf leer stellen und raus:
        if (this.selected != true && this.emptyIfDeselected === true && this.type != FilterOptionTypes.toggleButton) {
            this.setValue(null);
            return;
        }

        this.validateValue(); // prüfen ob zb Datum ausgewählt, aber nicht eingetragen wurde
        this.emit("valueChanged");
        this.emit("change", this);

    }

    private _onClick_toggleButton(evt: Event): void {
        //console.debug("_onClick_toggleButton", this.data.selected);

        //this.toggleSelected();
        //evt.stopPropagation();

        this.set("value", !this.data.selected);
    }

    private _onClick_selectButton(evt: Event): void {
        if (this.mandatory === true || this.alternativeMandatoryMode === true) return;

        this.toggleSelected();
        evt.stopPropagation();
    }

    private _handleInputChangeTimeoutHandle: any = null;

    private _handleInputChangeDelayed(delay?: number): void {
        if (this._handleInputChangeTimeoutHandle != null) {
            clearTimeout(this._handleInputChangeTimeoutHandle);
            this._handleInputChangeTimeoutHandle = null;
        }

        if (typeof (delay) != "undefined" && delay > 0) {

        } else {
            delay = 400;
        }

        this._handleInputChangeTimeoutHandle = setTimeout(lang.hitch(this, this._handleInputChange), delay);
    }



    private _handleInputChange(): void {

        if (this.mandatory != true) {

            if (this.type == FilterOptionTypes.multiselect) {
                let value = this.multiSelect_Widget.getValue();
                this._setSelectedAttr(value?.length > 0 || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.datetime) {
                let value = this.dateTime_Widget.getValue();
                this._setSelectedAttr(!!value?.date || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.multilinetext) {
                let value = this.multiline_Widget.getValue() as string;
                this._setSelectedAttr(value?.length > 0 || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.htmledit) {
                let value = this.htmledit_Widget.getValue();
                this._setSelectedAttr(value?.length > 0 || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.combobox) {
                let value = this.select_Widget.getValue(false);
                this._setSelectedAttr(!!value || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.dualcolor || this.type == FilterOptionTypes.simplecolor) {
                let value = this.color_Widget.getColor(true);
                this._setSelectedAttr(!!value || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.hintbox) {
                let value = this.hintbox_Widget.getValue("value");
                this._setSelectedAttr(!!value || this.alternativeMandatoryMode == true);
            } else {
                if (this._targetInput.value == "") {
                    this._setSelectedAttr(this.alternativeMandatoryMode);
                } else {
                    this._setSelectedAttr(true);
                }
            }
        }

        if (this.type == FilterOptionTypes.multiselect) {
            this._setValueAttr(this.multiSelect_Widget.getValue(), true);
        } else if (this.type == FilterOptionTypes.datetime) {
            this._setValueAttr(this.dateToLocalISOString(this.dateTime_Widget.getValue()?.date), true);
        } else if (this.type == FilterOptionTypes.multilinetext) {
            this._setValueAttr(this.multiline_Widget.getValue(), true);
        } else if (this.type == FilterOptionTypes.htmledit) {
            this._setValueAttr(this.htmledit_Widget.getValueBase64(), true)
        } else if (this.type == FilterOptionTypes.combobox) {
            this._setValueAttr(this.select_Widget.getValue(false), true);
        } else if (this.type == FilterOptionTypes.dualcolor || this.type == FilterOptionTypes.simplecolor) {
            this._setValueAttr(this.color_Widget.getDualColor(false, true) as any);
        } else if (this.type == FilterOptionTypes.float) {
            this._setValueAttr(parseFloat(this._targetInput.value), true);
        } else if (this.type == FilterOptionTypes.number) {
            this._setValueAttr(parseInt(this._targetInput.value), true);
        } else if (this.type == FilterOptionTypes.hintbox) {
            this._setValueAttr(this.hintbox_Widget.getValue("value"), true);
        } else {
            this._setValueAttr(this._targetInput.value, true);
        }
    }

    private _onChange_DateInput(evt: Event): void {
        //console.debug("_onChange_DateInput", this.date_Input.value);

        this._handleInputChange();
    }

    private _onChange_SelectInput(evt: Event): void {

        this._handleInputChange();

        //console.trace("_onChange_SelectInput", this.select_Widget, this.data);
    }

    private _onChange_TextInput(evt: Event): void {
        //console.debug("_onChange_TextInput", this.text_Input.value);
        this._handleInputChange();
    }

    private _onKeyUp_TextInput(evt: Event): void {
        this._handleInputChangeDelayed(222);
        setTimeout(lang.hitch(this, this.emit, "keyUp", evt), 50);
    }

    private _onChange_ColorPickerInput(): void {
        this._handleInputChange();
    }

    private _onChange_MultiSelectInput(evt: Event): void {
        this._handleInputChange();
    }
    private _onChange_MultilineInput(evt: Event): void {
        this._handleInputChange();
    }
    private _onChange_HtmlEditInput(evt: Event): void {
        this._handleInputChange();
    }
    private _onChange_HintboxInput(evt: Event): void {
        this._handleInputChange();
    }
    private _onChange_DateTimeInput(evt: Event): void {
        this._handleInputChange();
    }

    private validateValue(): boolean {
        var bSetToWarning = false;

        if (this.type == FilterOptionTypes.infotext) {
            this.valid = true;
            return this.valid;
        }

        if (this.mandatory != true) {

            if (this.data.selected == true && this.alternativeMandatoryMode != true) {
                // ausgewählt, aber kein Wert -> deshalb Warnung

                if (this.type == FilterOptionTypes.multiselect) {
                    bSetToWarning = this.multiSelect_Widget.getValue()?.length <= 0;
                } else if (this.type == FilterOptionTypes.datetime) {
                    bSetToWarning = !this.dateTime_Widget.getValue()?.date;
                } else if (this.type == FilterOptionTypes.multilinetext) {
                    bSetToWarning = !this.multiline_Widget.getValue();
                } else if (this.type == FilterOptionTypes.htmledit) {
                    bSetToWarning = !this.htmledit_Widget.getValue();
                } else if (this.type == FilterOptionTypes.combobox) {
                    bSetToWarning = !this.select_Widget.getValue(false);
                } else if (this.type == FilterOptionTypes.dualcolor || this.type == FilterOptionTypes.simplecolor) {
                    bSetToWarning = !this.color_Widget.getValue("full", true);
                }
                else if (this.type != FilterOptionTypes.toggleButton) {
                    if (this._targetInput) {
                        bSetToWarning = this._targetInput.value == "";
                    }
                }
            }
        } else {
            if (this.type == FilterOptionTypes.toggleButton) {
                bSetToWarning = false; // Toggles können nur ein oder aus sein
            } else if (this.type == FilterOptionTypes.multiselect) {
                bSetToWarning = this.multiSelect_Widget.getValue()?.length == 0;
            } else if (this.type == FilterOptionTypes.datetime) {
                bSetToWarning = !this.dateTime_Widget.getValue()?.date;
            } else if (this.type == FilterOptionTypes.multilinetext) {
                bSetToWarning = !this.multiline_Widget.getValue();
            } else if (this.type == FilterOptionTypes.htmledit) {
                bSetToWarning = !this.htmledit_Widget.getValue();
            } else if (this.type == FilterOptionTypes.hintbox) {
                bSetToWarning = !this.hintbox_Widget.getValue();
            } else if (this.type == FilterOptionTypes.combobox) {
                bSetToWarning = !this.select_Widget.getValue();
            } else if (this.type == FilterOptionTypes.dualcolor || this.type == FilterOptionTypes.simplecolor) {
                bSetToWarning = !this.color_Widget.getValue();
            }
            else {
                bSetToWarning = this._targetInput.value == "" || this._targetInput.value == null;
            }
        }

        if (this.type != FilterOptionTypes.toggleButton) {
            if (bSetToWarning != true) {
                if (this.type == FilterOptionTypes.text) {
                    if (this.selected == true) {
                        if (typeof (this.data.maxLength) != "undefined" && this.data.maxLength != null) {
                            bSetToWarning = bSetToWarning || this._targetInput.value.length > this.data.maxLength;
                        }
                        if (typeof (this.data.minLength) != "undefined" && this.data.minLength != null) {
                            bSetToWarning = bSetToWarning || this._targetInput.value.length < this.data.minLength;
                        }
                    }
                }
                if (this.type == FilterOptionTypes.multilinetext) {
                    if (this.selected == true) {
                        if (typeof (this.data.maxLength) != "undefined" && this.data.maxLength != null) {
                            bSetToWarning = bSetToWarning || this.multiline_Widget.getValue()?.length > this.data.maxLength;
                        }
                        if (typeof (this.data.minLength) != "undefined" && this.data.minLength != null) {
                            bSetToWarning = bSetToWarning || this.multiline_Widget.getValue()?.length < this.data.minLength;
                        }
                    }
                }

                if (this.type == FilterOptionTypes.htmledit) {
                    if (this.selected == true) {
                        if (typeof (this.data.maxLength) != "undefined" && this.data.maxLength != null) {
                            bSetToWarning = bSetToWarning || this.htmledit_Widget.getValue()?.length > this.data.maxLength;
                        }
                        if (typeof (this.data.minLength) != "undefined" && this.data.minLength != null) {
                            bSetToWarning = bSetToWarning || this.htmledit_Widget.getValue()?.length < this.data.minLength;
                        }
                    }
                }

                if (this.type == FilterOptionTypes.date) {
                    var date = new Date(this._targetInput.value);

                    if (this.selected == true) {
                        if (typeof (this.data.maxValue) != "undefined" && this.data.maxValue != null) {
                            var compareDate = new Date(this.data.maxValue);
                            bSetToWarning = bSetToWarning || date.valueOf() > compareDate.valueOf();
                        }
                        if (typeof (this.data.minValue) != "undefined" && this.data.minValue != null) {
                            var compareDate = new Date(this.data.minValue);
                            bSetToWarning = bSetToWarning || date.valueOf() < compareDate.valueOf();
                        }
                    }
                }

                if (this.type == FilterOptionTypes.datetime) {
                    let datevalue = this.dateTime_Widget.getValue()?.date;

                    if (this.selected == true && datevalue) {
                        if (typeof (this.data.maxValue) != "undefined" && this.data.maxValue != null) {
                            let compareDate = new Date(this.data.maxValue);
                            bSetToWarning = bSetToWarning || datevalue.valueOf() > compareDate.valueOf();
                        }
                        if (typeof (this.data.minValue) != "undefined" && this.data.minValue != null) {
                            let compareDate = new Date(this.data.minValue);
                            bSetToWarning = bSetToWarning || datevalue.valueOf() < compareDate.valueOf();
                        }
                    }
                }

                if ((this.type == FilterOptionTypes.number || this.type == FilterOptionTypes.float)) {
                    if (typeof (this.data.maxValue) != "undefined" && this.data.maxValue != null) {
                        bSetToWarning = bSetToWarning || parseFloat(this._targetInput.value) > this.data.maxValue;
                    }
                    if (typeof (this.data.minValue) != "undefined" && this.data.minValue != null) {
                        bSetToWarning = bSetToWarning || parseFloat(this._targetInput.value) < this.data.minValue;
                    }
                }

                if (this.type == FilterOptionTypes.multiselect) {
                    // aber nur wenn nicht aktiviert!
                    if (this.selected == true) {
                        if (typeof (this.data.maxLength) != "undefined" && this.data.maxLength != null) {
                            bSetToWarning = bSetToWarning || this.multiSelect_Widget.getValue()?.length > this.data.maxLength;
                        }
                        if (typeof (this.data.minLength) != "undefined" && this.data.minLength != null) {
                            bSetToWarning = bSetToWarning || this.multiSelect_Widget.getValue()?.length < this.data.minLength;
                        }
                    }
                }
            }
        }

        this.UiModder.domClass.toggle(this.warningNode, "w3-hide", !bSetToWarning);
        this.UiModder.domClass.toggle(this.domNode, "invalid", bSetToWarning);

        this.valid = bSetToWarning != true;
        return this.valid;
    }

    private _reset(): void {
        this.UiModder.domClass.add(this.toggleButton_Container, "w3-hide");
        this.UiModder. domClass.remove(this.toggleButton_Button, "w3-disable");
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

        this.data = {
            type: FilterOptionTypes.toggleButton,
            isMandatory: false,
            label: "?",
            name: "?",
            selected: false,
            value: "??"
        };
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        //console.debug("FPopt postcreate", this.data);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.toggleButton_Label, labelIdValue: "toggleButtonLabel"
            }],
            this.toggleButton_Button,
            this.id);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.date_Label, labelIdValue: "dateLabel"
            }],
            this.date_Input,
            this.id);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.dateTime_Label, labelIdValue: "dateTimeLabel"
            }],
            this.dateTime_InputContainer,
            this.id);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.multiline_Label, labelIdValue: "multilineLabel"
            }],
            this.multiline_InputContainer,
            this.id);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.htmledit_Label, labelIdValue: "htmleditLabel"
            }],
            this.htmledit_InputContainer,
            this.id);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.hintbox_Label, labelIdValue: "hintboxLabel"
            }],
            this.hintbox_InputContainer,
            this.id);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.select_Label, labelIdValue: "selectLabel"
            }],
            this.select_InputContainer,
            this.id);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.text_Label, labelIdValue: "textLabel"
            }],
            this.text_Input,
            this.id);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.multiSelect_Label, labelIdValue: "multiSelectLabel"
            }],
            this.multiSelect_InputContainer,
            this.id);

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.color_Label, labelIdValue: "colorLabel"
            }],
            this.color_InputContainer,
            this.id);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FilterPanelOption);
